require("!!/home/uplanner/rosario-front/node_modules/script-loader/addScript.js")(require("!!/home/uplanner/rosario-front/node_modules/raw-loader/index.js!/home/uplanner/rosario-front/bower_components/angular-bootstrap-calendar/dist/js/angular-bootstrap-calendar-tpls.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/angular-bootstrap-calendar/dist/js/angular-bootstrap-calendar-tpls.js
// module id = 1521
// module chunks = 0